<template>
    <div>
        <div
            :id="lifeStyleImagesMobileId"
            :class="'md:hidden grid grid-rows-' + lifeStyleImageLength"
        >
            <media
                v-for="(image, i) in lifeStyleImages"
                :key="i"
                :media="image.image"
                :alt="image.alt"
                media-classes="w-full h-96 object-cover border-slate-500 border-solid border"
                default-media-type="image"
            />
        </div>
        <div
            :id="lifeStyleImagesId"
            :class="'hidden md:grid grid-cols-' + lifeStyleImageLength"
        >
            <media
                v-for="(image, i) in lifeStyleImages"
                :key="i"
                :media="image.image"
                :alt="image.alt"
                media-classes="w-full h-96 object-cover border-slate-500 border-solid border"
                default-media-type="image"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from "vue";
    import Media from "@/components/Media.vue";
    interface LifestyleImage {
        image: string;
        alt: string;
    }

    let { lifeStyleImages } = defineProps({
        lifeStyleImages: {
            type: Array as PropType<LifestyleImage[]>,
            required: true
        }
    });

    let lifeStyleImageLength = computed(() => lifeStyleImages.length);

    let lifeStyleImagesId = computed(() => {
        return "life-style-images-" + Math.random().toString(36).substring(7);
    });

    let lifeStyleImagesMobileId = computed(() => {
        return (
            "mobile-life-style-images-" +
            Math.random().toString(36).substring(7)
        );
    });
</script>

<style scoped>
    img {
        position: relative;
    }
    img::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
    }
</style>
